module.exports = __webpack_public_path__ + "assets/img/commission2@2x.85c874f6.png";